var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 10 10",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M3 1h4M2 2h1m4 0h1M1 3h1m6 0h1M1 4h1m6 0h1M1 5h1m6 0h1M1 6h1m6 0h1M2 7h1m4 0h1M3 8h4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#e2d17a",
    d: "M3 2h4M2 3h2M2 4h1M2 5h1M2 6h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#e8a127",
    d: "M4 3h3M3 4h4M3 5h4M3 6h3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ba8968",
    d: "M7 3h1M7 4h1M7 5h1M6 6h2M3 7h4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamoc);
export default __webpack_public_path__ + "static/media/teamoc.f0061a453b86ee9de96639966ae74342.svg";
export { ForwardRef as ReactComponent };